// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class GISPointGEOResource extends Resource {
    basePath: string = 'networks/maps/{parent}/gis-points/';

    objectPath: string = 'networks/maps/{parent}/gis-points/{ident}/';

    list(parentId: string, query: Object, signal: AbortSignal): Promise<Object> {
        return this.client._request(this._getBasePath(parentId), 'GET', query,
            {}, 'same-origin', false, signal).then((response) => response.data);
    }
}
